import {
  SET_ACTIVE_SECTION,
  SET_ACTIVE_TAB_PROJET,
  SET_ACTIVE_PROJET,
  RESET_DASHBOARD,
  SET_ACTIVE_TAB_MATCH,
  SET_ACTIVE_TAB_APPEL_OFFRE,
  SET_ACTIVE_TAB_PROPOSITION_SELECTED,
  SET_ACTIVE_APPEL_OFFRE,
  SET_ACTIVE_TAB_MATCH_APPEL_OFFRE,
  SET_ACTIVE_CLIENT,
  SET_ACTIVE_PRESTATAIRE,
  SET_ACTIVE_ADMIN,
  SET_ACTIVE_ROLE,
  SET_ACTIVE_DONNEUR_ORDRE,
  SET_ACTIVE_USER,
  SET_ACTIVE_USER_TAB
} from "../actions/dashboardActions";

const initialState = {
  activeSection: "",
  activeTabProjet: "",
  activeTabMatch: "",
  activeTabPropositionSelected: "",
  activeTabMatchAppelOffre: "",
  activeTabAppelOffre: "",
  activeProjet: null,
  activeAppelOffre: null,
  activePrestataire: null,
  activeAdmin: null,
  activeClient: null,
  activeRole: "client",
  activeDonneurOrdre: null,
  activeUser: null,
  activeUserTab: "perso",
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_SECTION:
      return {
        ...state,
        activeSection: action.payload,
      };

    case SET_ACTIVE_TAB_PROJET:
      return {
        ...state,
        activeTabProjet: action.payload,
      };

    case SET_ACTIVE_TAB_MATCH:
      return {
        ...state,
        activeTabMatch: action.payload,
      };

    case SET_ACTIVE_TAB_PROPOSITION_SELECTED:
      return {
        ...state,
        activeTabPropositionSelected: action.payload,
      };

    case SET_ACTIVE_TAB_APPEL_OFFRE:
      return {
        ...state,
        activeTabAppelOffre: action.payload,
      };

    case SET_ACTIVE_TAB_MATCH_APPEL_OFFRE:
      return {
        ...state,
        activeTabMatchAppelOffre: action.payload,
      };

    case SET_ACTIVE_PROJET:
      return {
        ...state,
        activeProjet: action.payload,
      };

    case SET_ACTIVE_APPEL_OFFRE:
      return {
        ...state,
        activeAppelOffre: action.payload,
      };
    
    case SET_ACTIVE_CLIENT:
      return {
        ...state,
        activeClient: action.payload,
      };

    case SET_ACTIVE_PRESTATAIRE:
      return {
        ...state,
        activePrestataire: action.payload,
      };

    case SET_ACTIVE_DONNEUR_ORDRE:
      return {
        ...state,
        activeDonneurOrdre: action.payload,
      };

    case SET_ACTIVE_ADMIN:
      return {
        ...state,
        activeAdmin: action.payload,
      };

    case SET_ACTIVE_USER:
      return {
        ...state,
        activeUser: action.payload,
      };
        
    case SET_ACTIVE_USER_TAB:
      return {
        ...state,
        activeUserTab: action.payload,
      };

    case SET_ACTIVE_ROLE:
      return {
        ...state,
        activeRole: action.payload,
      };

    case RESET_DASHBOARD:
      return initialState;

    default:
      return state;
  }
};

export default dashboardReducer;
